import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M20.5 7h-3.001c.315-.418.501-.938.501-1.5C18 4.122 16.878 3 15.5 3c-1.39 0-2.556 1.101-3.127 1.758-.346.397-.644.823-.873 1.235-.229-.412-.527-.837-.873-1.235C10.056 4.102 8.89 3 7.5 3 6.122 3 5 4.122 5 5.5c0 .562.187 1.082.501 1.5H2.5c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5H3v9.5c0 .827.673 1.5 1.5 1.5h14c.827 0 1.5-.673 1.5-1.5V11h.5c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5zm-7.373-1.586C13.909 4.515 14.774 4 15.5 4c.827 0 1.5.673 1.5 1.5S16.327 7 15.5 7h-3.378c.173-.442.523-1.032 1.005-1.586zM13 21h-3V8h3v13zM6 5.5C6 4.673 6.673 4 7.5 4c.726 0 1.591.515 2.373 1.414.482.554.832 1.144 1.005 1.586H7.5C6.673 7 6 6.327 6 5.5zM3 8h6v2H3V8zm1 12.5V11h5v10H4.5c-.276 0-.5-.224-.5-.5zm15 0c0 .276-.224.5-.5.5H14V11h5v9.5zM20 10h-6V8h6v2z',
  ],
  height: 24,
  width: 24,
});
